import { useState } from 'react';
import { outboundAPI } from '../api/client';
import type { OutboundSafetyStatus } from '../types';

interface OutboundBannerProps {
  outbound: OutboundSafetyStatus | null;
  onResumed?: () => void;
}

export function OutboundBanner({ outbound, onResumed }: OutboundBannerProps) {
  const [busy, setBusy] = useState(false);

  if (!outbound || outbound.circuit_breaker.state !== 'open') {
    return null;
  }

  async function handleResume() {
    try {
      setBusy(true);
      await outboundAPI.resumeCircuitBreaker();
      onResumed?.();
    } catch (err) {
      console.error('Failed to resume circuit breaker:', err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-4 mt-2 rounded-xl border border-warning/40 bg-warning-bg px-3 py-2">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-warning" data-ph-no-mask>Outbound paused</p>
          <p className="text-sm text-ink mt-1">
            Autonomous sends are paused after {outbound.circuit_breaker.consecutive_failures} consecutive failures.
          </p>
        </div>
        <button
          onClick={() => void handleResume()}
          disabled={busy}
          className="text-xs px-3 py-1.5 rounded-md border border-warning text-warning bg-white hover:bg-warning-bg disabled:opacity-50"
          data-ph-no-mask
        >
          {busy ? 'Resuming...' : 'Resume'}
        </button>
      </div>
    </div>
  );
}

export default OutboundBanner;
